import { Component, OnInit } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { delay } from 'rxjs';
import { riskLevelOptions } from '../../services/ref';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@UntilDestroy()
@Component({
    selector: 'risk-level-form',
    templateUrl: './risk-level-form.component.html',
    styleUrls: ['./risk-level-form.component.scss'],
    standalone: false
})
export class RiskLevelFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  options = riskLevelOptions;
  error: ValidationErrors = null;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
    const productType = this.subscriptionFacade.getPledge()?.productType || '';
    const type =
      productType !== 'SCPI' ? productType?.toLowerCase() : productType;
    const message = `Si vous souhaitez réaliser un investissement à capital et/ou revenus garantis, l'investissement en parts de ${type} n'est pas adapté à vos objectifs. Veuillez vous rapprocher de votre conseiller pour obtenir des renseignements complémentaires.`;

    this.form
      .get('riskLevelExpected')
      .valueChanges.pipe(
        delay(0),

        untilDestroyed(this),
      )
      .subscribe(data => {
        if (
          data == 'NO_RISK' ||
          (productType == 'CROWDFUNDING' && data != 'HIGH_RISK')
        ) {
          this.form.get('riskLevelExpected').setErrors({
            incorrect: true,

            message: message,
          });
        } else {
          this.form.get('riskLevelExpected').setErrors(null);
        }
        this.error = this.form.get('riskLevelExpected').errors;
      });
  }

  onSubmit() {
    this.form.markAsDirty();
    if (!this.error) {
      this.subscriptionFacade.submitPledge(this);
    }
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
